/**
 * Datos legales del vendedor. Fontanería común de Dropai: no edites este archivo.
 * Los valores reales van en src/legal-info.ts, que es de la tienda.
 */

export interface StoreLegalInfo {
  /** Nombre y apellidos (autónomo) o razón social (sociedad). */
  sellerName: string;
  /** NIF o CIF. */
  taxId: string;
  /** Domicilio completo. */
  address: string;
  email: string;
  phone?: string;
  /** Solo sociedades: Registro Mercantil, tomo, folio y hoja. Si no es una sociedad, se quita. */
  registry?: string;
  /** A dónde se envía: "España peninsular". */
  shippingScope: string;
  /** Plazo de entrega. Si falta, se informa del máximo legal de 30 días. */
  shippingTime?: string;
  /** Precio del envío tal y como se enseña: "4,95 €", "Gratis". */
  shippingCost?: string;
  /** Quién paga la devolución: "Los pagas tú", "Los paga la tienda". */
  returnCosts: string;
  /** Desistimiento: 14 días naturales (mínimo legal en la UE). */
  returnsDays: 14;
  /** Garantía legal de conformidad: 3 años (España). */
  warrantyYears: 3;
  /** Fecha de la última actualización de los textos legales. */
  updatedAt: string;
}

/** Los huecos por defecto: entre corchetes, para que se vean y se rellenen antes de publicar. */
export const legalPlaceholders: StoreLegalInfo = {
  sellerName: "[Nombre o razón social]",
  taxId: "[NIF]",
  address: "[Dirección completa]",
  email: "[Correo de contacto]",
  phone: "[Teléfono]",
  registry: "[Solo sociedades: Registro Mercantil, tomo, folio y hoja]",
  shippingScope: "[Zonas de envío, p. ej. España peninsular]",
  shippingTime: "[Plazo de entrega, p. ej. de 5 a 8 días laborables]",
  shippingCost: "[Precio del envío]",
  returnCosts: "[Quién paga la devolución: tú o la tienda]",
  returnsDays: 14,
  warrantyYears: 3,
  updatedAt: "[fecha]",
};

export const PLACEHOLDER_HINT = "Texto de ejemplo: sustitúyelo por tus datos reales";

/** Un dato sin rellenar: "[NIF]", o vacío. */
export function isPlaceholder(value: string | undefined): boolean {
  const text = value?.trim() ?? "";
  return text === "" || (text.startsWith("[") && text.endsWith("]"));
}

/** Si queda algún hueco por rellenar en los datos legales. */
export function hasPlaceholders(info: StoreLegalInfo): boolean {
  return Object.values(info).some((value) => typeof value === "string" && isPlaceholder(value));
}
